module.exports = __webpack_public_path__ + "static/media/2020.8.11未成年人制作飞机活动.cf43dd56.jpg";